/*
  Upsell de sombrero en el carrito.

  Los listeners van delegados en document a proposito: el cart drawer se
  re-renderiza entero (renderContents reemplaza el innerHTML) cada vez que
  cambia el carrito, asi que cualquier listener puesto sobre los elementos
  internos se perderia. Delegando en document sobrevive a los re-renders.

  El precio de $50.000 NO se fuerza desde aqui: se agrega el sombrero a su
  precio normal y el descuento automatico de Shopify ("Sombrero a $50.000 con
  tu compra") lo baja solo si hay otro producto en el carrito.
*/
(function () {
  function closeList(card) {
    var list = card.querySelector('[data-hat-list]');
    var toggle = card.querySelector('[data-hat-toggle]');
    if (list) list.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    // Abrir / cerrar el desplegable
    var toggle = event.target.closest('[data-hat-toggle]');
    if (toggle) {
      var card = toggle.closest('[data-hat-upsell]');
      var list = card && card.querySelector('[data-hat-list]');
      if (!list) return;
      var open = list.hidden;
      list.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    // Elegir sombrero
    var option = event.target.closest('[data-hat-option]');
    if (option) {
      var card = option.closest('[data-hat-upsell]');
      if (!card) return;
      card.querySelectorAll('[data-hat-option]').forEach(function (o) {
        o.classList.remove('is-selected');
        o.setAttribute('aria-selected', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-selected', 'true');
      card.setAttribute('data-selected-variant', option.getAttribute('data-variant'));

      var current = card.querySelector('[data-hat-current]');
      if (current) {
        current.innerHTML = '';
        var img = document.createElement('img');
        img.src = option.getAttribute('data-img');
        img.alt = '';
        current.appendChild(img);
        current.appendChild(document.createTextNode(option.getAttribute('data-name')));
      }
      var add = card.querySelector('[data-hat-upsell-add]');
      if (add) {
        add.disabled = false;
        var label = add.querySelector('.hat-upsell__add__label');
        if (label) label.textContent = label.getAttribute('data-label-ready');
      }
      closeList(card);
      return;
    }

    // Clic fuera: cerrar desplegables abiertos
    document.querySelectorAll('[data-hat-upsell]').forEach(function (card) {
      if (!card.contains(event.target)) closeList(card);
    });
  });

  // Agregar al carrito
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-hat-upsell-add]');
    if (!btn) return;
    var card = btn.closest('[data-hat-upsell]');
    if (!card) return;

    var variantId = card.getAttribute('data-selected-variant');
    if (!variantId) return;

    var label = btn.querySelector('.hat-upsell__add__label');
    var labelOriginal = label ? label.textContent : '';
    var spinner = btn.querySelector('.hat-upsell__add__spinner');
    btn.disabled = true;
    if (label) label.textContent = 'Agregando...';
    if (spinner) spinner.hidden = false;

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };

    // Pedirle a Shopify que devuelva las secciones ya renderizadas, para que el
    // drawer se actualice con el descuento ya aplicado sin recargar la pagina.
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.disabled = false;
        if (label) label.textContent = labelOriginal;
        if (spinner) spinner.hidden = true;
      });
  });
})();
